import { ClerkProvider as OGClerkProvider } from "@clerk/clerk-expo";
import { tokenCache } from "@clerk/clerk-expo/token-cache";

export default function ClerkProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <OGClerkProvider
      publishableKey={process.env.EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY}
      tokenCache={tokenCache}
    >
      {children}
    </OGClerkProvider>
  );
}
